import { useState, useEffect } from "react";
import { API } from '../flux/api/order-api';

export const useLoadMoreOrders = (width: number) => {
    const [data, setData] = useState<any>([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [noMoreOrders, setNoMoreOrders] = useState(false);
    const [error, setError] = useState<any>(false);

    const fetchData = async (page: number, statusFilter: string[], fromFilterChange = false) => {
        if (width > 500) return [];
        setLoading(true);
        fromFilterChange && setPage(1);
        try {
            await API.getOrders(page, 6, statusFilter).then((response: any) => {
                const { orders } = response.data;
                setData(orders);
                setLoading(false);
                setError(false);
                setNoMoreOrders(orders.length === 0 || orders.length < 6);
            });
        } catch (error) {
            setError(error);
        }

        return data;
    }

    const loadMore = async (statusFilter: string[]) => {
        setPage(page + 1);
        const moreData: Array<any> = await fetchData(page + 1, statusFilter);
        setData((prev: Array<any>) => [...moreData, ...prev]);
    }

    useEffect(() => {
        fetchData(page, []);
    }, []);

    return [data, loadMore, loading, fetchData, noMoreOrders, error];
}
